import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import TrafficTracker from "@/components/TrafficTracker";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import Membership from "@/pages/Membership";
import HelpCenter from "@/pages/HelpCenter";
import Addresses from "@/pages/Addresses";
import Admin from "@/pages/Admin";
import Chat from "@/pages/Chat";
import MyDeals from "@/pages/MyDeals";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <TrafficTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/help" element={<HelpCenter />} />
              <Route path="/addresses" element={<Addresses />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/deals" element={<MyDeals />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
